function numberFormat(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
    const dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
    
    const toFixedFix = function (n, prec) {
      const k = Math.pow(10, prec);
      return '' + Math.round(n * k) / k;
    };
  
    let s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    
    return s.join(dec);
  }
  
  export function formatAmount(amount, siteInfo, currentLang) {
    if (!siteInfo || !currentLang) {
      return amount?.toString() || '0';
    }
  
    let formattedAmount = amount.toString();
  
    if (siteInfo.priceThousandsSeparator !== null) {
      formattedAmount = numberFormat(formattedAmount, 0, '.', siteInfo.priceThousandsSeparator);
    }
  
    const currencySymbol = window.currencySymbol || siteInfo.symbol || '€';
  
    const cleanAmount = formattedAmount.replace(currencySymbol, '');
  
    const currencyPosition = siteInfo.languages?.[currentLang]?.currencyPosition || '11';
  
    switch (currencyPosition) {
      case '00':
        return currencySymbol + cleanAmount;
        
      case '01':
        return currencySymbol + " " + cleanAmount;
        
      case '10':
        return cleanAmount + currencySymbol;
        
      case '11':
      default:
        return cleanAmount + " " + currencySymbol;
    }
  }